module.exports = __webpack_public_path__ + "img/Los Angeles Times.718d2197.svg";